<template>
<b-card>

    <div class="d-flex align-items-center justify-content-between mb-1">
        <div class="d-flex align-items-center">
            <h4 class="d-inline-block mr-1" >{{$t('Status History')}}</h4>
            <span v-if="period" class="text-muted font-small-2 ml-2">{{ period }}</span>
        </div>
    </div>
  <b-row>
    <b-col md="12">
      <div class="container mb-1">
        <div><p class="font-weight-bolder">{{ $t('Legend') }}</p></div>
        <div class="row">
          <div class="col-md-2 col-sm-4 status">
            <span class="dot dot-off"></span>
            <span class="font-weight-bolder font-small-2">{{ $t('Off') }}</span>
          </div>
          <div class="col-md-2 col-sm-4 status">
            <span class="dot dot-on"></span>
            <span class="font-weight-bolder font-small-2">{{ $t('On') }}</span>
          </div>
          <div class="col-md-2 col-sm-4 status">
            <span class="dot dot-no-connection"></span>
            <span class="font-weight-bolder font-small-2">{{ $t('No Connection') }}</span>
          </div>
          <div class="col-md-2 col-sm-4 status">
            <span class="dot dot-idle"></span>
            <span class="font-weight-bolder font-small-2">{{ $t('Idle Use') }}</span>
          </div>
          <div class="col-md-2 col-sm-4 status">
            <span class="dot dot-severe-use"></span>
            <span class="font-weight-bolder font-small-2">{{ $t('Severe Use') }}</span>
          </div>
          <div class="col-md-2 col-sm-4 status">
            <span class="dot dot-failure"></span>
            <span class="font-weight-bolder font-small-2">{{ $t('Failure') }}</span>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
    <div id="chart">
        <vue-apex-charts type="rangeBar" :height="isMultipleDays ? 160 : 135" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</b-card>
</template>

<script>

import {
  BCard,
  BAvatar,
  BButton, BRow, BCol
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { getIntlLocale } from '@/libs/i18n/dateLocale'
import {
    $themeColors
} from '@themeConfig'

export default {
    components: {
      BCol, BRow,
        BCard,
        BAvatar,
        VueApexCharts,
        BButton
    },
    computed: {
        series() {
            return this.dataWorkStatus
        },
        isMultipleDays() {
            const minTime = this.minTime !== null && this.minTime !== undefined 
                ? this.minTime 
                : (() => {
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    return today.getTime()
                })()
            
            const maxTime = this.maxTime !== null && this.maxTime !== undefined 
                ? this.maxTime 
                : (() => {
                    const today = new Date()
                    today.setHours(23, 59, 59, 999)
                    return today.getTime()
                })()
            
            // Determinar se é múltiplos dias (diferença maior que 1 dia em milissegundos)
            return (maxTime - minTime) > (24 * 60 * 60 * 1000)
        },
        chartOptions() {
            // Calcular minTime e maxTime baseado nas props ou usar valores padrão do dia atual
            const minTime = this.minTime !== null && this.minTime !== undefined 
                ? this.minTime 
                : (() => {
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    return today.getTime()
                })()
            
            const maxTime = this.maxTime !== null && this.maxTime !== undefined 
                ? this.maxTime 
                : (() => {
                    const today = new Date()
                    today.setHours(23, 59, 59, 999)
                    return today.getTime()
                })()

            // Usar a computed property isMultipleDays
            const isMultipleDays = this.isMultipleDays
            const untilLabel = this.$t('until')

            // Gerar annotations para separar dias visualmente
            let annotations = {}
            if (isMultipleDays) {
                const annotationsXaxis = []
                const minDate = new Date(minTime)
                const maxDate = new Date(maxTime)
                
                // Começar do dia seguinte ao minTime
                const currentDay = new Date(minDate)
                currentDay.setDate(currentDay.getDate() + 1)
                currentDay.setHours(0, 0, 0, 0)
                
                // Adicionar linhas de separação até o maxDate
                while (currentDay <= maxDate) {
                    const midnightTime = currentDay.getTime()
                    
                    annotationsXaxis.push({
                        x: midnightTime,
                        strokeDashArray: 4,
                        borderColor: '#b4b7bd',
                        opacity: 0.5,
                        label: {
                            borderColor: '#b4b7bd',
                            style: {
                                color: '#6e6b7b',
                                background: '#f8f9fa',
                                fontSize: '10px',
                                padding: {
                                    left: 4,
                                    right: 4,
                                    top: 2,
                                    bottom: 2
                                }
                            },
                            text: currentDay.toLocaleDateString(getIntlLocale(), { day: '2-digit', month: '2-digit' })
                        }
                    })
                    
                    // Próximo dia
                    currentDay.setDate(currentDay.getDate() + 1)
                }
                
                annotations = { xaxis: annotationsXaxis }
            }

            return {
                chart: {
                    height: isMultipleDays ? 160 : 135,
                    type: 'rangeBar',
                    toolbar: {
                        show: true,
                        tools: {
                            download: false,
                            pan: true,
                            zoom: true,
                            reset: true,
                        },
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '50%',
                        rangeBarGroupRows: true
                    },
                    dataLabels: {
                        enabled: false,
                    },
                },
                fill: {
                    type: 'solid'
                },
                grid: {
                    show: true,
                    borderColor: '#e0e0e0',
                    strokeDashArray: 0,
                    xaxis: {
                        lines: {
                            show: isMultipleDays,
                        }
                    }
                },
                annotations: annotations,
                xaxis: {
                    type: 'datetime',
                    min: minTime,
                    max: maxTime,
                    labels: {
                        format: isMultipleDays ? 'dd/MM HH:mm' : 'HH:mm',
                        datetimeUTC: false,
                        rotate: isMultipleDays ? -45 : 0,
                        style: {
                            fontSize: isMultipleDays ? '10px' : '12px',
                            colors: '#6e6b7b'
                        }
                    },
                    axisBorder: {
                        show: true,
                        color: '#e0e0e0'
                    }
                },
                yaxis: {
                    labels: false,
                },
                legend: {
                    show: false,
                },
                tooltip: {
                    custom(data) {
                        const startDate = new Date(data.y1)
                        const endDate = new Date(data.y2)
                        
                        const dayStart = String(startDate.getDate()).padStart(2, '0')
                        const monthStart = String(startDate.getMonth() + 1).padStart(2, '0')
                        const yearStart = startDate.getFullYear()
                        const hourStart = String(startDate.getHours()).padStart(2, '0')
                        const minuteStart = String(startDate.getMinutes()).padStart(2, '0')
                        
                        const dayEnd = String(endDate.getDate()).padStart(2, '0')
                        const monthEnd = String(endDate.getMonth() + 1).padStart(2, '0')
                        const yearEnd = endDate.getFullYear()
                        const hourEnd = String(endDate.getHours()).padStart(2, '0')
                        const minuteEnd = String(endDate.getMinutes()).padStart(2, '0')
                        
                        const values = data.ctx.rangeBar.getTooltipValues(data)
                        
                        // Se for múltiplos dias, mostrar data e hora completa, senão só hora
                        const startStr = isMultipleDays 
                            ? `${dayStart}/${monthStart}/${yearStart} ${hourStart}:${minuteStart}` 
                            : `${hourStart}:${minuteStart}`
                        const endStr = isMultipleDays 
                            ? `${dayEnd}/${monthEnd}/${yearEnd} ${hourEnd}:${minuteEnd}` 
                            : `${hourEnd}:${minuteEnd}`
                        
                        return `<div class="px-1 py-50"><span><strong>${values.seriesName}</strong><br/>${startStr} ${untilLabel} ${endStr}</span></div>`
                    },
                },
            }
        }
    },
    mounted() {
    },
    watch: {
        dataWorkStatus: function (newVal, oldVal) {
            // Series é computed, atualiza automaticamente
        },
        minTime: function () {
            // Forçar atualização do gráfico quando minTime mudar
            this.$forceUpdate()
        },
        maxTime: function () {
            // Forçar atualização do gráfico quando maxTime mudar
            this.$forceUpdate()
        }
    },
    props: {
        dataWorkStatus: {
            type: Array,
            required: true,
            default: []
        },
        assetId: {
            type: String,
            required: true
        },
        minTime: {
            type: Number,
            default: null
        },
        maxTime: {
            type: Number,
            default: null
        },
        period: {
            type: String,
            default: ''
        }
    },
    methods: {
       

    },
    
}

function utcToLocalDate(date) {
            var myDate = date;
            var offset = myDate.getTimezoneOffset() * 60 * 1000;

            var withOffset = myDate.getTime();
            var withoutOffset = withOffset - offset;

            return withoutOffset;
        }

        function    resolveMin(){
            const dt = new Date();
            dt.setHours(4);
            dt.setMinutes(0);

            return utcToLocalDate(dt);
        }

        function    resolveMax(){
            const dt = new Date();
            dt.setHours(20);
            dt.setMinutes(0);

            return utcToLocalDate(dt);
        }
</script>

<style scoped>
.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
}

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 5px;
}

.dot-off {
  background-color: #747679;
}

.dot-on {
  background-color: #47cd83;
}

.dot-no-connection {
  background-color: rgba(198, 217, 245, 0.85);
}

.dot-idle {
  background-color: #25d4ea;
}

.dot-severe-use {
  background-color: #feab5e;
}

.dot-failure {
  background-color: #ea5455;
}
</style>
